// The PUBLIC site's Stimulus controllers (P10.3).
//
// Hand-maintained, and that is deliberate. This file replaces half of the
// generated `index.js`, which registered all 24 controllers into whichever
// bundle imported it — so the staff console's drawer, its bulk uploader and
// its live queue shipped to every visitor on the public site, even though
// `public.js`'s own first comment says the two bundles are separate on
// purpose. The generator cannot know which surface a controller belongs to;
// only a person can, so the split is written down instead of derived.
//
// `test/lib/bundle_separation_test.rb` (T90) is what keeps this honest:
// every controller file must appear in at least one manifest, so dropping
// `stimulus:manifest:update` cannot quietly leave a new controller
// unregistered.
//
// Shared controllers are listed in BOTH manifests. They are shared because a
// partial under app/views/shared renders on both surfaces (the booth picker,
// the filter sheet, the focus announcer) — not because it was easier. The
// dialog and upload controllers left this list with shared/_dialog and
// shared/_upload: only admin views use them now.
import { application } from "./application"

// ---- Public only -----------------------------------------------------------
import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DirectoryController from "./directory_controller"
application.register("directory", DirectoryController)

import FaqFilterController from "./faq_filter_controller"
application.register("faq-filter", FaqFilterController)


import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LogoUploadController from "./logo_upload_controller"
application.register("logo-upload", LogoUploadController)

import PreparedDetailsController from "./prepared_details_controller"
application.register("prepared-details", PreparedDetailsController)

import PublicFloorPlanController from "./public_floor_plan_controller"
application.register("public-floor-plan", PublicFloorPlanController)

import PublicNavController from "./public_nav_controller"
application.register("public-nav", PublicNavController)

import RegistrationStepsController from "./registration_steps_controller"
application.register("registration-steps", RegistrationStepsController)

import RepeatableRowsController from "./repeatable_rows_controller"
application.register("repeatable-rows", RepeatableRowsController)

import SurveyController from "./survey_controller"
application.register("survey", SurveyController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

// ---- Shared with the admin -------------------------------------------------
import BoothPickerController from "./booth_picker_controller"
application.register("booth-picker", BoothPickerController)

// NO TOAST CONTROLLER. The public layout has never rendered a toast — flash on
// the public site is handled by the page it belongs to — so registering one
// here shipped a controller to every visitor that nothing on their page could
// use. `BundleSeparationTest` only noticed when P12.14 moved the partial into
// `admin/shared`, which made the usage scan classify `toast` as admin-only.

import FilterSheetController from "./filter_sheet_controller"
application.register("filter-sheet", FilterSheetController)

// The floor plan EDITOR (floor_plan_controller.js) is not here: it is used
// only under app/views/admin, and it grew with P14 (add, delete, copy and
// paste, smart guides). The public plan and the picker use public-floor-plan
// and booth-picker with the shared map-viewport.

import MapViewportController from "./map_viewport_controller"
application.register("map-viewport", MapViewportController)

import FocusAnnouncerController from "./focus_announcer_controller"
application.register("focus-announcer", FocusAnnouncerController)


